import React, { useMemo } from 'react';
import styles from './video-player.module.scss';
import VideoUtil from '../../../../common/utils/VideoUtil';
import Player from '../../../components/Player';

function VideoPlayer(props) {
  const { uuid, originalURL, thumbnailURL, scenes, moduleClassName = '', playerClassName = '', processingMessage, ...rest } = props;
  const videoUrl = useMemo(() => {
    const videoCodecSupported = VideoUtil.checkBrowserSupportedVideoType();
    console.log('Codec supported:', videoCodecSupported);
    return originalURL;
  }, [originalURL]);

  return (
    <Player
      key={uuid}
      uuid={uuid}
      scenes={scenes}
      src={videoUrl}
      poster={thumbnailURL}
      styling={{ moduleClassName: moduleClassName, playerClassName: playerClassName }}
      error={!videoUrl}
      processingMessage={processingMessage}
      {...rest}
    />
  );
}

export default VideoPlayer;
